/* Технические работы: состояние платформы. */

import type { MaintenanceState } from '@andresot/protocol/envelope';
import { request } from './client.js';

/**
 * Маршрут открыт и без входа: экран с отсчётом нужен и тому, кто ещё не
 * вошёл, и тому, кому сервер уже отказывает во всём остальном.
 */
export async function fetchMaintenance(): Promise<MaintenanceState> {
	const { maintenance } = await request<{ maintenance: MaintenanceState }>('/api/maintenance', {
		method: 'GET'
	});
	return maintenance;
}
